<div class="d-flex justify-content-center align-items-center loader-backdrop" *ngIf="this.isActive | async">
  <div class="spinner-border" style="width: 3rem; height: 3rem" role="status"></div>
</div>
